import { InputLabel, MenuItem, Select, Stack } from "@mui/material";
import { ChartType } from "enums/report";
import { isFunction } from "lodash";

interface Props {
  isOwner: boolean;
  chartType?: ChartType;
  handleChangeChartType?: Function;
}

export default function ReportTabsChartType({
  isOwner,
  chartType,
  handleChangeChartType,
}: Props) {
  return (
    <Stack spacing={1} width={200}>
      <InputLabel htmlFor="chart-type">Chart Type</InputLabel>
      <Select
        disabled={false}
        variant="outlined"
        value={chartType || ""}
        onChange={(event) =>
          isFunction(handleChangeChartType) &&
          handleChangeChartType(event.target.value)
        }
      >
        <MenuItem value="">
          <em>NONE</em>
        </MenuItem>
        <MenuItem value={ChartType.LINE}>{ChartType.LINE}</MenuItem>
        <MenuItem value={ChartType.PIE}>{ChartType.PIE}</MenuItem>
        <MenuItem value={ChartType.DOUGHNUT}>{ChartType.DOUGHNUT}</MenuItem>
        <MenuItem value={ChartType.BAR}>{ChartType.BAR}</MenuItem>
        <MenuItem value={ChartType.TREND_LINE}>{ChartType.TREND_LINE}</MenuItem>
        <MenuItem value={ChartType.MULTI_AXIS}>{ChartType.MULTI_AXIS}</MenuItem>
        <MenuItem value={ChartType.STACKED_BAR}>
          {ChartType.STACKED_BAR}
        </MenuItem>
        <MenuItem value={ChartType.STACKED_BAR_GROUP}>
          {ChartType.STACKED_BAR_GROUP}
        </MenuItem>
        <MenuItem value={ChartType.STACKED_BAR_LINE}>
          {ChartType.STACKED_BAR_LINE}
        </MenuItem>
      </Select>
    </Stack>
  );
}
